import React from "react";
import MaterialHeader from "../../components/MaterialHeader";
import { Outlet } from "react-router-dom";

import Layout from "../Layout";

const Material = () => {
  return (
    <Layout>
      {/* <MaterialWrapper> */}

      {/* <div className='relative container mx-auto'> */}

      {/* <div className='container mx-auto px-4 py-8 space-y-6 z-30'> */}
      {/* <MaterialHeader/> */}
      <Outlet />
      {/* </div> */}
      {/* </div> */}
      {/* </MaterialWrapper> */}
    </Layout>
  );
};

export default Material;
